import { Pipe, PipeTransform } from '@angular/core';
import * as ssf from 'ssf';

@Pipe({
  name: 'excelFormat',
  standalone: true
})
export class ExcelFormatPipe implements PipeTransform {
  transform(value: any, format: string): string {
    if (value === null || value === undefined || !format) {
      return value;
    }
    const isNumericFormat = /[0#]/.test(format);
    let formattedValue = value;  

    if (typeof value === 'string' && isNumericFormat && !isNaN(Number(value))) {
      formattedValue = Number(value);
    }

    try {
      return ssf.format(format, formattedValue);
    } catch (e) {
      console.error(`Error applying Excel format "${format}" to value "${value}"`, e);
      return value;
    }
  }
}